module.exports = __webpack_public_path__ + "static/media/turkey.10b07ddc.jpg";